import '../css/App.css';
import Carousel from "../Components/Carousel";
import PageSection from "../Components/PageSection";
import pharaohBig from "../images/pharaoh-cover-big.jpg";
import RITHBig from "../images/RITH_big.jpg";
import LongTomMed from "../images/longtom-med.jpg";
import Newsletter from '../Components/Newsletter';

function Home() {

  return (
    <div>

      <div class="text-divider">Complete Works</div>
      <Carousel />

       <PageSection 
        headerText="Long Tom: Behind the Woods" 
        divider="New Release" 
        showOppositeSide={false}
        banner="Final Book of the Behind the World Trilogy" 
        sectionContent={[
          "What lies at the back of the isolated hollow in the depths of eastern Tennessee? A glowing power of hope? Or a breach in the gates of Hell? Five sentinels stand ceaseless watch over the entrance to what locals call the Lonely, a rich, vibrant stand of forest that birds, animals, and even insects will not enter. And which kills any person who lingers too long within its shadows.",
            "“The entrance is threatened.” Thus reads the enigmatic warning received by Father Homer, and he hears the voice of God in those few words. Despite the protestations of his companion, Francisco Stampa, it is enough to send him to answer a desperate appeal for help from a terrified Lutheran minister in a small Tennessee town besieged by the forest, by fear, and by the growing enmity of a being calling himself Major Long Tom Gordon.",
            "Long Tom: Behind the Woods is the thundering conclusion of the Behind the World trilogy, and the conflicts that surged through Black Jack: Behind the Waves and Mortimer: Behind the Walls come to a stunning climax as dark questions are answered and ancient secrets revealed. ",
        ]}
        sideLink="https://www.amazon.com/gp/product/B0GL9MJ392"
        sidePicture={LongTomMed}
      />

      <PageSection 
        headerText="Pharaoh's Mountain" 
        divider="Recent Release" 
        showOppositeSide={true}
        banner="Can a Graverobber's Defiance Shatter an Empire?" 
        sectionContent={["The Great Tomb of the Pharaoh Khufu, a monstrous thing in pyramid shape, dominates all Egypt.", 
          "The labor of thirty years by an entire kingdom, the Tomb is the confirmation of the superiority of the 4th Dynasty over all the rulers who came before. And the monument in whose shadow the generations of Khufu's heirs will forever shelter against any who would seek to overthrow them.",
          "No graverobber would dream of attacking the Great Tomb. It is ringed by temples of dedicated priests, guarded by the regiment that had protected Khufu in life, and defended by the ingenuity of legions of architects and the curses of a dozen gods.",
          "Yet its very prestige may be its undoing. For if the Tomb could be violated within weeks of Khufu's internment, its entire meaning would be negated, proving to the world that even with the expenditure of such labor, treasure, and cunning, the new Dynasty is unable to protect their dead.",
          "So for those who have chafed under Khufu's iron fist, the first blow of their rebellion must not be against flesh. But against stone.",
          "The rebels soon find the man they need: Dahshur, an experienced graverobber who has broken a hundred tombs. A man who despises priests, mocks kings, and has nothing but contempt for the magics woven to protect the dead. An atheist in the Land of the Gods.",
          "As the new Pharaoh's army strikes the rebels in Upper Egypt, Dahshur's team moves against the Tomb. And they succeed in breaking through. Only to find themselves enmeshed in dark plots, diabolic traps, and the growing, terrifying certainty they have unleashed the wrath of the gods."
        ]}
        sideLink="https://www.amazon.com/Pharaohs-Mountain-James-Hillebrecht-ebook/dp/B0D8L6H5HR"
        sidePicture={pharaohBig}
      />

      <PageSection 
        headerText="PRAISE FOR JAMES' WORK" 
        divider="Reviews" 
        showOppositeSide={false}
        banner="Reviews from Amazon" 
        sectionContent={["\"From having an extensive history of reading Forgotten Realms, Dragonlance, Ravenloft Series Novels, along with Tolkien and of course the many works of R.A. Salvatore... this trilogy fits right in with the best of them, the realms are different but it seems based on the same AD&D principles of the others and a thoroughly good read.\" - Amazon Customer",
          "\"To put it simply, I adored a Rage in the Heavens...as a reader it was wonderful to let myself be swept away by such an epic tale, with its epic battles and terrible villains, rooting for the heroes to come out on top. I started the next volume in the trilogy, Upon This World of Stone, as soon as I finished the first!\" - K.E. Bucher"
        ]}
        sideLink="https://www.amazon.com/Rage-Heavens-Book-Paladin-Trilogy-ebook/dp/B0818W9LQW"
        sidePicture={RITHBig}
      />

      <Newsletter />


</div>

  );
}

export default Home;
